// @ts-nocheck



import React from 'react';
import ReactJson from 'react18-json-view';
import 'react18-json-view/src/style.css';












const updateFromEvent = (onChange) => ({
  src


}) => {
  onChange(src);
};

const JsonViewer = ({ value, onChange, ...props }) => {
  const update = updateFromEvent(onChange);

  return (
    <ReactJson
      {...props}
      src={value}
      name={false}
      onEdit={update}
      onAdd={update}
      onDelete={update} />);


};

export default JsonViewer;
